export const NO_INSERT_MODE = true;
export const DIMENSIONS_LANG = 'nameHe'; //TODO: replace with interface language 
export const TITLE_MAX_CHARS = 40;
export const SUBTITLE_MAX_CHARS = 200;
export const SUMMARY_MAX_CHARS = 300;
export const SUMMARY_MAX_CHARS_BOOK = 20000;
export const URL_MAX_CHARS = 500;
export const COURSE_CONTENT_MAX_CHARS = 1000;
export const COURSE_CONTENT_MAX_ROWS = 8;
export const DISCIPLINES_MAX = 4;
export const SYLLABUS_MAX = 3;
export const SKILLS_MAX = 4;

export const SYLLABUS_SUBJECT_ID = 'subjectId';
export const SYLLABUS_SUBSUBJECT_ID = 'subsubjectId';

export const SKILLS_SUBJECT_ID = 'skillId';
export const SKILLS_SUBSUBJECT_ID = 'subskillId';